<template>
  <div id="app">
    <transition name="slide-fade" mode="out-in">
      <router-view v-if="authenticated == true"></router-view>
    </transition>
  </div>
</template>

<script>
  // import auth0Lock from 'auth0-lock';
  import auth0 from 'auth0-js';
  import Vue from 'vue';
  import { mapState } from 'vuex';
  import store from './vuex/store';
  import authService from './services/authService';
  // import "../src/assets/css/cropperjs.css";

  const checkAuth = function () {
    return !!localStorage.getItem('id_token');
  };

  // const auth0LockOptions = {
  //   allowedConnections: ['Username-Password-Authentication', 'Google'],
  //   theme: {
  //     logo: 'https://s3.amazonaws.com/images.stitchvideo.net/stitch-bug-sm.png',
  //     primaryColor: '#00ae8c'
  //   },
  //   languageDictionary: {
  //     title: 'Stitch'
  //   },
  //   auth: {
  //     redirectUrl: window.document.location.protocol + '//' + window.document.location.host + '/',
  //     responseType: 'token',
  //     sso: false,
  //     params: {
  //       scope: 'openid email user_metadata app_metadata picture'
  //     }
  //   }
  // };

  export default {
    name: 'app',
    computed: mapState({
      useraccount: state => state.user.useraccount,
      siteuser: state => state.user.siteuser
    }),
    data() {
      return {
        playerBase: process.env.PLAYER_URI,
        authenticated: false,
        secretThing: '',
        // lock: new auth0Lock(process.env.AUTH0_CLIENT_ID, 'stitch.auth0.com', auth0LockOptions)

      };
    },
    events: {
      logout() {
        this.logout();
      }
    },
    // Check the user's auth status when the app
    // loads to account for page refreshing
    mounted() {

      var self = this;

      // persist route on refresh
      if(!localStorage.getItem('logout') && checkAuth()) {
        self.authenticated = true;
        self.getUser();
        return;
      }

      self.webAuth = new auth0.WebAuth({
          domain: process.env.AUTH0_DOMAIN,
          clientID: process.env.AUTH0_CLIENT_ID,
          responseType: 'token id_token',
          // audience: `https://${process.env.AUTH0_DOMAIN}/userinfo`,
          params: {
            scope: 'openid email user_metadata app_metadata picture profile'
          },
          auth: {
            params: {
              scope: 'openid email user_metadata app_metadata picture profile'
            }
          },
          scope: 'openid email user_metadata app_metadata picture profile',
          redirectUri: window.document.location.protocol + '//' + window.document.location.host + '/',
        });

      Vue.nextTick(function () {
        self.handleAuthentication();
        // self.authenticated = checkAuth();
        // if (!self.authenticated) {
        //   self.login();
        // } else {
        //   if (!self.siteuser._id) {
        //     self.getUser();
        //   }
        // }

        // self.lock.on('authenticated', (authResult) => {
        //   localStorage.setItem('id_token', authResult.idToken);
        //   self.lock.getProfile(authResult.idToken, (error, profile) => {
        //     if (error) {
        //       // Handle error
        //       return;
        //     }
        //     // Set the token and user profile in local storage
        //     localStorage.setItem('profile', JSON.stringify(profile));
        //     self.authenticated = true;
        //     self.getUser();
        //     const redirectUri = authService.getRedirectUri();
        //     // Remove from storage to avoid using it if the user logs out intentionally.
        //     authService.removeRedirectUriFromStorage();
        //     window.location = redirectUri;
        //   });
        // });
        // self.lock.on('authorization_error', (error) => {
        //   // handle error when authorizaton fails
        //   self.logout();
        // });
      });
    },
    created() {
      // Add the script tag.
      this.loadRhebusVideoPlayer();
    },
    methods: {
      login() {
        //this.lock.show();
        this.webAuth.authorize();
      },
      logout() {
        // To log out, we just need to remove the token and profile
        // from local storage
        localStorage.removeItem('logout');
        localStorage.removeItem('id_token');
        localStorage.removeItem('profile');
        localStorage.removeItem('access_token');
        localStorage.removeItem('expires_in');
        localStorage.removeItem('impersonate');
        this.authenticated = false;

        // Auth0 logout
        this.webAuth.logout({
          returnTo: window.document.location.protocol + '//' + window.document.location.host + '/',
          clientID: process.env.AUTH0_CLIENT_ID,
        });
      },
      // Make a secure call to the server by attaching
      // the user's JWT as an Authorization header
      getUser() {
        store.dispatch('user/loadSiteuser').then(function (resp, err) {
          store.dispatch('user/loadSiteuserAccount').then(function (resp, err) {
          });
        });
      },
      loadRhebusVideoPlayer() {
        const scriptId = 'rhebusvideo-loader-preview';
        const d = document;
        if (d.getElementById(scriptId)) return;
        const fjs = d.getElementsByTagName('script')[0];
        const js = d.createElement('script');
        js.src = `//${this.playerBase}/js/load.js`;
        js.id = scriptId;
        fjs.parentNode.insertBefore(js, fjs);
      },
      handleAuthentication() {
        var self = this;
        /**
        // self.authenticated = checkAuth();
        // if (!self.authenticated) {
        //   self.login();
        // } else {
        //   if (!self.siteuser._id) {
        //     self.getUser();
        //   }
        // }

        // self.lock.on('authenticated', (authResult) => {
        //   localStorage.setItem('id_token', authResult.idToken);
        //   self.lock.getProfile(authResult.idToken, (error, profile) => {
        //     if (error) {
        //       // Handle error
        //       return;
        //     }
        //     // Set the token and user profile in local storage
        //     localStorage.setItem('profile', JSON.stringify(profile));
        //     self.authenticated = true;
        //     self.getUser();
        //     const redirectUri = authService.getRedirectUri();
        //     // Remove from storage to avoid using it if the user logs out intentionally.
        //     authService.removeRedirectUriFromStorage();
        //     window.location = redirectUri;
        //   });
        // });
        // self.lock.on('authorization_error', (error) => {
        //   // handle error when authorizaton fails
        //   self.logout();
        // });
        */

        if(localStorage.getItem('logout')) {
          return self.logout();
        }

        this.webAuth.parseHash(function(err, authResult) {
          // console.log('parseHash', err, authResult);


          if (authResult && authResult.accessToken && authResult.idToken) {
            localStorage.setItem('id_token', authResult.idToken);
            localStorage.setItem('access_token', authResult.accessToken);
            localStorage.setItem('expires_in', authResult.expiresIn);
            // console.log(authResult.idTokenPayload);
            const profile = {
              user_id: authResult.idTokenPayload.sub,
              user_email: authResult.idTokenPayload.email,
              nickname: authResult.idTokenPayload.nickname,
              picture: authResult.idTokenPayload.picture,
              authorization: authResult.idTokenPayload['https://rhebus.works/app_metadata'].authorization,
              user_metadata: authResult.idTokenPayload['https://rhebus.works/user_metadata'],
            };
            // console.log(profile);

            localStorage.setItem('profile', JSON.stringify(profile));
            self.authenticated = true;
            self.getUser();
            const redirectUri = authService.getRedirectUri();
            // Remove from storage to avoid using it if the user logs out intentionally.
            authService.removeRedirectUriFromStorage();
            // console.log(redirectUri);
            // window.location = redirectUri;

        //   localStorage.setItem('id_token', authResult.idToken);
        //   self.lock.getProfile(authResult.idToken, (error, profile) => {
        //     if (error) {
        //       // Handle error
        //       return;
        //     }
        //     // Set the token and user profile in local storage
        //     localStorage.setItem('profile', JSON.stringify(profile));
        //     self.authenticated = true;
        //     self.getUser();
        //     const redirectUri = authService.getRedirectUri();
        //     // Remove from storage to avoid using it if the user logs out intentionally.
        //     authService.removeRedirectUriFromStorage();
        //     window.location = redirectUri;
        //   });
            //setSession(authResult);
          } else if (err) {
              console.log(err);
              self.logout();
          } else {
            // console.log(self);
            // console.log(this);
            self.login();
          }

          // displayButtons();
        });
      }
    }
  };
</script>

<style>
  @import '~vue-material/dist/vue-material.css';
  @import '~animate.css/animate.css';
  @import './assets/css/material-design-icons.css'; /* still depending on material-design icons for md-table-pagination */
  @import './assets/css/rhebus.css';

  .slide-fade-enter-active {
    transition: all .2s ease;
  }

  .slide-fade-leave-active {
    transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }

  .slide-fade-enter, .slide-fade-leave-active {
    transform: translateX(10px);
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue